<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: '微软雅黑', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  background:#0E132D;
}
@font-face {
  font-family: 'DINCond';
  src: url("../static/font/DINCond-Bold.otf") format("tpentype"),
    url("../static/font/DINCond-Bold.ttf") format("truetype");
}
*{
  padding: 0;
  margin: 0;
}
body{background:#0E132D;}
</style>



// WEBPACK FOOTER //
// src/App.vue